import { useFetchUserPermissionsQuery } from '@backrs_ui/grow-ui/src/redux/user/user.api';
import { UIPermissionList } from '@backrs_ui/grow-ui/src/redux/user/user.transformer';

export const useHasPermission = (permission: keyof UIPermissionList): boolean => {
  const { data: userPermissions } = useFetchUserPermissionsQuery(undefined);

  return userPermissions?.[permission]?.allowed ?? false;
};
